export const CUSTOMIZE_PAYMENTS = 'CUSTOMIZE_PAYMENTS';
export const DEALERSHIP_NAME_PRICE = 'DEALERSHIP_NAME_PRICE';
export const DETAILED_PRICING = 'DETAILED_PRICING';
export const DETAILS = 'DETAILS';
export const EPRICE_PENDING = 'EPRICE_PENDING';
export const EST_FINANCE_DISCLAIMER_HEADING = 'EST_FINANCE_DISCLAIMER_HEADING';
export const EST_LEASE_DISCLAIMER_HEADING = 'EST_LEASE_DISCLAIMER_HEADING';
export const FINANCE = 'FINANCE';
export const FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE =
	'FINANCE_DRIVER_FINANCE_PAYMENT_TOOLTIP_VERBIAGE';
export const FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE =
	'FINANCE_DRIVER_LEASE_PAYMENT_TOOLTIP_VERBIAGE';
export const FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE =
	'FINANCE_DRIVER_PAYMENT_INFO_VDP_TOOLTIP_VERBIAGE';
export const INSTANT_EPRICE_DISABLED_POPOVER =
	'INSTANT_EPRICE_DISABLED_POPOVER';
export const LEASE = 'LEASE';
export const PER_MONTH = 'PER_MONTH';
export const PLEASE_CALL = 'PLEASE_CALL';
export const PLUS_SALES_TAXES_ASTERISK = 'PLUS_SALES_TAXES_ASTERISK';
export const PLUS_TAXES_ASTERISK = 'PLUS_TAXES_ASTERISK';
export const SLASH_MO = 'SLASH_MO';
export const THE_DEALERSHIP = 'THE_DEALERSHIP';



// WEBPACK FOOTER //
// ./src/constants/labels.js